<template lang="pug">
  .form
    h4.form__title {{ form.label }}

    .form__fields
      form-field(
        v-for='field in form.fields'
        :key='field.name'
        :field='field'
        :form-type='form.name'
        :model.sync='values'
      )

    .form__extra
      h4.headline Comentarios y Conclusión

      form-field(
        :field='comments'
        :form-type='form.name'
        :model.sync='values'
      )
      form-field(
        :field='conclusion'
        :form-type='form.name'
        :model.sync='values'
      )
</template>

<script>
import formField from '@/components/form-field';

export default {
  components: { formField },

  data() {
    return {
      comments: {
        name: 'comments',
        label: 'Comentarios',
        type: 'textarea',
      },
      conclusion: {
        name: 'conclusion',
        label: 'Conclusión',
        type: 'textarea',
      },
    };
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    values: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="less">
@import '~@/stylesheets/modules/colors';

.form {
  padding: 2rem 0;
  margin: 0 -.5rem;

  &__title {
    color: lighten(@pink, 10%);
    font-size: 1.75em;
    margin: 0 1rem 2rem;
  }

  &__fields {
    display: flex;
    flex-flow: row wrap;
  }

  .form-field {
    width: ~"calc(50% - 2rem)";
    margin: 0 1rem;

    &.title {
      color: lighten(@light-blue, 10%);
      margin: 2rem 1rem 1rem;
      width: 100%;
    }
  }

  &__extra {
    .headline {
      color: @light-blue;
      margin: 1rem;
    }

    .form-field {
      width: auto;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/study-form.vue